@if (isContractCreated === true) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }
  <div class="contract-created-card">
    <div class="contract-created-content">
      <h1>{{ 'TRANSLATE.CONGRATULATIONS' | translate }}</h1>
      <h3>
        {{ 'TRANSLATE.YOU.HAVE.JUST.PURCHASED.FORD.PROTECT' | translate }} <br />
        {{ 'TRANSLATE.NEXT.YOU.CAN.ACCESS.CONTRACT.TEXT' | translate }} <br />
        {{ 'TRANSLATE.THANK.YOU.AND.COUNT.ON.US' | translate }}
      </h3>
    </div>
    <div class="col-12 md:col-12 lg:col-12 button-position-download contract-created-action">
      <button id="btnDownload" class="btn-download contract-created-download" type="button"
        [disabled]="isDownloadingContract" [ngClass]="{ 'is-loading': isDownloadingContract }"
        [attr.aria-busy]="isDownloadingContract" (click)="downloadPDF()">
        @if (!isDownloadingContract) {
        <i class="pi pi-download" aria-hidden="true"></i>
        }
        @if (isDownloadingContract) {
        <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
        }
        <span class="btn-download-label">
          {{ (isDownloadingContract ? 'TRANSLATE.DOWNLOADING.TERMS.OF.AGREEMENT' :
          'TRANSLATE.DOWNLOAD.TERMS.OF.AGREEMENT') | translate }}
        </span>
      </button>
    </div>
  </div>
</div>
}

@if (isContractCreated === false) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }
  <form [formGroup]="contractForm">
    <div class="legal-main-card">
      <table id="pdfContractTwo" #pdfContractTwo style="width:100%; height:100% ">
        <tr>
          <td align="justify" width="100%">
            <div class="col-10 col-offset-1">
              <div class="p-fluid">
                <table style="width: 100%;" border="0px">
                  <tbody id="fordImage">
                    <tr>
                      <td style="text-align: left;">
                        <img style="width: 380px; height: 80px;"
                          src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png" alt="">
                      </td>
                    </tr>
                  </tbody>
                </table>
                <span class="client-data-field-text contract-doc-title">
                  TERMO DE CONTRATAÇÃO – SEGURO GARANTIA ESTENDIDA REDUZIDA
                </span>
                <br>
                <span class="client-data-field-text contract-section-title">
                  Dados do Segurado
                </span>
                <br>
                <br>
                <span class="client-data-field-text">
                  <table border="0">
                    <tr class="margin-line">
                      <td colspan="3">Nome: {{ clientData.firstname }} {{ clientData.lastname }}</td>
                    </tr>
                    @if (clientData.customerSocialName !== null || clientData.customerSocialName !== undefined) {
                    <tr class="margin-line">
                      <td colspan="3">Nome Social: {{ clientData.customerSocialName }}</td>
                    </tr>
                    }
                    <tr class="margin-line">
                      <td colspan="3">CPF: {{ maskCpfAndCnpj(clientData.nationalId) }}</td>
                    </tr>
                    <tr class="margin-line">
                      <td>Endereço: {{ clientData.address }}, {{ clientData.number }} {{
                        clientData.complement }}</td>
                      <td>&nbsp;&nbsp;</td>
                      <td>Cep: {{ maskZipCode(clientData.zip) }}</td>
                    </tr>
                    <tr>
                      <td>Bairro: {{ clientData.district }}</td>
                      <td>&nbsp;&nbsp;</td>
                      <td>Cidade: {{ clientData.city }} UF: {{ clientData.stateCode }}</td>
                    </tr>
                  </table>
                </span>
                <br>
                <br>
                <span class="client-data-field-text contract-section-title">
                  Dados do Seguro
                </span>
                <br>
                <br>
                <span class="client-data-field-text">
                  <b>Extensão de Garantia ({{choosePlanBuyng.extension.limitDistance}} km /
                    {{(choosePlanBuyng.extension.limitTime+choosePlanBuyng.factoryTimeLimit)/12}}
                    anos)</b>
                  <br>
                  <br>
                  Início e término de vigência da cobertura: Conforme informação do bilhete de seguro a
                  ser emitido. O bilhete
                  somente será emitido, e enviado por e-mail automaticamente ao cliente, após a
                  disponibilização do chassi do veículo.
                </span>
                <br>
                <br>
                <span class="client-data-field-text contract-section-title">
                  Dados do Veículo
                </span>
                <br>
                <br>
                <div class="vehicle-data-block">
                  <div class="vehicle-data-row client-data-field-text">
                    <span class="summary-label">Chassi:</span>
                    <span class="summary-value">{{ vinValidate.vin }}</span>
                  </div>
                  <div class="vehicle-data-row client-data-field-text">
                    <span class="summary-label">Modelo:</span>
                    <span class="summary-value">{{ vinValidate.modelName }}</span>
                  </div>
                  <div class="vehicle-data-row client-data-field-text">
                    <span class="summary-label">Ano:</span>
                    <span class="summary-value">{{ vinValidate.modelYear }}</span>
                  </div>
                  <div class="vehicle-data-row client-data-field-text">
                    <span class="summary-label">Odômetro:</span>
                    <span class="summary-value">{{ maskOdometer(vinValidate.odometro) }}</span>
                  </div>
                  <span class="vehicle-data-notes-title client-data-field-text">
                    <b>Notas:</b>
                  </span>
                </div>
                <span class="client-data-field-text vehicle-data-notes-text">
                  1) A contratação de seguro é opcional, sendo possível a desistência do contrato em até 7
                  (sete) dias corridos, com a
                  devolução integral do valor pago, a contar da assinatura da proposta, no caso de
                  contratação por bilhete individual, ou da
                  emissão do bilhete, no caso de contratação por bilhete, ou do efetivo pagamento do
                  prêmio, o que ocorrer por último. É
                  proibido condicionar desconto no preço do bem à aquisição do seguro.
                  <br>
                  2) No caso de pagamento de prêmio fracionado, considera-se o pagamento da primeira
                  parcela como o efetivo pagamento.
                </span>
                <br><br>
                <span class="client-data-field-text">
                  Garantido por AIG Seguros Brasil S/A. CNPJ 33.040.981/0001-50 | Central de Atendimento
                  AIG 24 horas: 0800 726 6130 /
                  Atendimento AIG a Deficientes Auditivos: 0800 724 0149 | Ouvidoria (2ª a 6ª-feira, das
                  9h às 18h): 0800 724 02 19 /
                  Ouvidoria - Atendimento a Deficientes Auditivos e de fala (2ª a 6ª-feira, das 9h às
                  18h): 0800 200 1244. O registro deste
                  plano na SUSEP não implica, por parte da Autarquia, incentivo ou recomendação a sua
                  comercialização. Consulte sempre a
                  versão das Condições Gerais do produto específico para informações completas. PROCESSO
                  SUSEP – nº
                  15414.649128/2023-86.
                  <br>
                  Representante de Seguros: Ford Motor Company Brasil Ltda. CNPJ 03.470.727/0004-73.
                </span>
                <br>
                <br>
                <span class="client-data-field-text contract-section-title">
                  Declaração do Segurado
                </span>
                <br>
                <br>
                <span class="client-data-field-text">
                  Confirmo que tomei ciência das Condições Gerais do produto e que recebi o caminho
                  eletrônico que consta o documento
                  que está disponibilizado digitalmente para consulta a qualquer momento
                  (https://www.aig.com.br/condicoes-gerais) e, assim,
                  autorizo a emissão do Bilhete de Seguro.
                </span>
                <br>
                <br>
                <span class="client-data-field-text contract-section-title">
                  Pessoa Politicamente Exposta
                </span>
                <br>
                <br>
                <span class="client-data-field-text">
                  Se na aceitação do risco for constatado que o segurado e/ou participante deste seguro
                  está classificado como Pessoa
                  Politicamente Exposta (conforme estabelecido na Circular SUSEP 612/2020), a seguradora
                  reserva-se o direito de solicitar
                  informações complementares em formulário padrão e documentos comprobatórios. Em casos
                  específicos, a seguradora
                  poderá solicitar documentação adicional sobre os principais administradores e
                  procuradores da companhia a fim de garantir
                  o devido cumprimento da referida circular.
                  <br>
                  1. Circular SUSEP 612/2020 - Art. 4º Para fins desta Circular, consideram-se expostas
                  politicamente as pessoas naturais
                  que ocupem ou tenham ocupado, nos 5 (cinco) anos anteriores, empregos ou funções
                  públicas relevantes, assim como
                  funções relevantes em organizações internacionais.
                  <br>
                  2. Formulário padrão poderá ser solicitado através do e-mail: csgservices&#64;aig.com
                </span>
                <br>
                <br>
                <span class="client-data-field-text contract-section-title">
                  Termos e Condições
                </span>
                <br>
                <br>
                <span class="client-data-field-text">
                  Ao fornecer suas informações pessoais neste formulário, você concorda e confirma, nos
                  termos da Lei 13.709/2019, o seu
                  consentimento para a coleta, tratamento, utilização e compartilhamento de suas
                  informações pessoais pela American
                  International Group, Inc. (AIG), ou qualquer de suas subsidiárias e afiliadas, para seus
                  prestadores de serviços,
                  resseguradores e representantes de seguros que estejam diretamente relacionados à oferta
                  do seu Bilhete de Seguro de
                  Garantia Estendida Reduzida, bem como em caso de regulação de sinistro e também de outra
                  forma estabelecida nas suas
                  políticas de privacidade. Se você incluir informações pessoais de terceiros, você
                  confirma ter autorização e que informou a
                  esta pessoa como a AIG usará essas informações nos termos descritos acima.
                  <br><br>
                  Declara ter ciência de que poderá exercer os seus direitos de confirmação de existência
                  de tratamento; acesso aos dados;
                  correção; anonimização, dentre outros, através do Serviço de Atendimento ao Cliente –
                  Fale com a AIG, incluindo, junto de
                  seu pedido, as seguintes informações: nome completo, tipo e número de documento de
                  identificação, número do bilhete do
                  seguro, telefone para contato, e e-mail.
                </span>
                <br><br><br>
                <div class="signature-consent-section">
                  <div class="consent-card">
                    <div class="consent-check" #termsConsent [class.terms-focus-active]="termsFocusActive">
                      <p-checkbox id="termsUser" binary="true" [(ngModel)]="termsUser" formControlName="termsUser"
                        required (onChange)="onTermsChange()"></p-checkbox>
                      <label for="termsUser" class="consent-label">
                        <b>{{ 'TRANSLATE.DECLARE.THAT.HAVE.READ.AGREE.CONDITIONS' | translate }}</b>
                      </label>
                    </div>
                    @if (submitted && f.termsUser?.errors) {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.REQUIRED.FIELD' | translate }}">
                    </p-message>
                    }
                  </div>
                  <div class="signature-meta-card">
                    <span class="signature-meta-label">{{ 'TRANSLATE.PLACE.DATE' | translate }}</span>
                    <span class="signature-meta-value">São Paulo, {{ getDay() }} de {{ getMonth() }} de {{ getYear()
                      }}</span>
                  </div>
                  <div class="signature-panel">
                    <div class="signature-panel-header">
                      <span class="signature-panel-title">{{ 'TRANSLATE.TWO.POINTS.INSURED.SIGNATURE' | translate
                        }}</span>
                    </div>
                    <div class="signature-box-container signature-canvas-shell" #signatureShell
                      [class.is-drawing]="isDrawing" [class.has-error]="submitted && f.signature?.errors">
                      <app-signature-pad #signaturePad formControlName="signature" (changed)="drawComplete()"
                        (drawing)="isDrawing = $event"></app-signature-pad>
                    </div>
                    @if (submitted && f.signature?.errors) {
                    <p-message class="client-data-message" severity="error"
                      text="{{ 'TRANSLATE.REQUIRED.FIELD' | translate }}">
                    </p-message>
                    }
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
      <table #pdfContractTwo style="width:100%; height:100% ">
        <tr>
          <td align="justify" width="100%">
            <div class="col-12 md:col-12 lg:col-12 button-position">
              <button id="btnReturn" class="undo-action-button return app-clean-button" type="button"
                (click)="buttonComeBack()" [disabled]="isSubmitted">
                <i class="pi pi-arrow-left" aria-hidden="true"></i>
                <span class="undo-action-button-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
              </button>
              <button id="btnClear" class="undo-action-button clear app-clean-button" type="button"
                (click)="drawClean()" [disabled]="isSubmitted">
                <i class="pi pi-trash" aria-hidden="true"></i>
                <span class="undo-action-button-label">
                  {{ 'TRANSLATE.CLEAR.SIGNATURE' | translate }}
                </span>
              </button>
              <app-cta-button [label]="'TRANSLATE.FINALIZE'" [loadingLabel]="'TRANSLATE.FINISHING'" icon="pi-check"
                [loading]="isSubmitted" [successState]="isCtaSuccess" (buttonClick)="buttonSave()">
              </app-cta-button>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </form>
</div>
}